/*
 * Copyright © 2024 Opera Norway AS. All rights reserved.
 *
 * This file is an original work developed by Opera.
 */

import React from 'react';
import styles from './LegalPage.module.css';
import Subpage from './components/Subpage';

import logoHorizontal from './img/logoHorizontal.svg';

const LegalPage = () => {
  const libraries = [
    {
      name: 'react',
      url: 'https://github.com/facebook/react',
      copyrights: ['Copyright (c) Meta Platforms, Inc. and affiliates.'],
    },
    {
      name: 'react router',
      url: 'https://github.com/remix-run/react-router',
      copyrights: [
        'Copyright (c) React Training LLC 2015-2019',
        'Copyright (c) Remix Software Inc. 2020-2021',
        'Copyright (c) Shopify Inc. 2022-2023',
      ],
    },
    {
      name: 'react-scripts',
      url: 'https://www.npmjs.com/package/react-scripts',
      copyrights: ['Copyright (c) 2013-present, Facebook, Inc.'],
    },
    {
      name: 'qr-scanner',
      url: 'https://www.npmjs.com/package/qr-scanner',
      copyrights: ['Copyright (c) 2017 Nimiq, danimoh'],
    },
    {
      name: 'express',
      url: 'https://www.npmjs.com/package/express',
      copyrights: [
        'Copyright (c) 2009-2014 TJ Holowaychuk <tj@vision-media.ca>',
        'Copyright (c) 2013-2014 Roman Shtylman <shtylman+expressjs@gmail.com>',
        'Copyright (c) 2014-2015 Douglas Christopher Wilson <doug@somethingdoug.com>',
      ],
    },
    {
      name: 'ws',
      url: 'https://www.npmjs.com/package/ws',
      copyrights: [
        'Copyright (c) 2011 Einar Otto Stangvik <einaros@gmail.com>',
        'Copyright (c) 2016 Luigi Pinca and contributors',
      ],
    },
  ];

  const mitLicenseText =
    'MIT License\n\n' +
    'Permission is hereby granted, free of charge, to any person obtaining a copy of\n' +
    'this software and associated documentation files (the "Software"), to deal in the\n' +
    'Software without restriction, including without limitation the rights to use, copy,\n' +
    'modify, merge, publish, distribute, sublicense, and/or sell copies of the Software,\n' +
    'and to permit persons to whom the Software is furnished to do so, subject to the\n' +
    'following conditions:\n\n' +
    'The above copyright notice and this permission notice shall be included in all\n' +
    'copies or substantial portions of the Software.\n\n' +
    'THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,\n' +
    'INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A\n' +
    'PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT\n' +
    'HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF\n' +
    'CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE\n' +
    'OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.';

  return (
    <Subpage title='Legal information'>
      <div className={styles.header}>
        <div className={styles.logoContainer}>
          <img
            src={logoHorizontal}
            alt='Opera GX Logo'
            className={styles.logoHorizontal}
          />
          <div className={styles.versionContainer}>
            <div className={styles.version}>Version: 0.1.0</div>
          </div>
        </div>
      </div>
      <div className={styles.notices}>
        <h1>Third Party Notices</h1>
        <h3>
          The following sets forth attribution notices for third-party software
          that may be contained in GX Connect.
        </h3>
        {libraries.map((lib, index) => (
          <div key={index}>
            <h3>
              <a href={lib.url} target='_blank' rel='noopener noreferrer'>
                {lib.name}
              </a>
            </h3>
            <p>
              <strong>Copyright Notices:</strong>
            </p>
            <pre>
              {lib.copyrights.map((line, idx) => (
                <div key={idx}>{line}</div>
              ))}
            </pre>
          </div>
        ))}
        <p>
          <strong>License Text:</strong>
        </p>
        <pre>{mitLicenseText}</pre>
      </div>
    </Subpage>
  );
};

export default LegalPage;
